import React, { useEffect, useMemo, useRef, useState } from "react";

// Login Component
function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const validUser = "admin";      
  const validPass = "1234";       

  const handleSubmit = (e) => {
    e.preventDefault();

    if (username === validUser && password === validPass) {
      sessionStorage.setItem("loggedIn", "true");
      onLogin(true);
    } else {
      alert("Λάθος username ή password");
    }
  };

  return (
    <div style={{ 
      minHeight: "100vh", 
      background: "#2a3550", 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center",
      fontFamily: "system-ui, Segoe UI, Roboto, Arial"
    }}>
      <div style={{ 
        width: "350px", 
        background: "linear-gradient(180deg,rgba(255,255,255,.04),rgba(255,255,255,.02))",
        border: "1px solid rgba(255,255,255,.08)",
        borderRadius: 14,
        boxShadow: "0 10px 30px rgba(0,0,0,.25)",
        padding: "32px",
        color: "#f2f6fb"
      }}>
        <h2 style={{ marginTop: 0, textAlign: "center", marginBottom: "24px" }}>Σύνδεση</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", marginBottom: "6px", fontSize: "14px" }}>Username</label>
            <input
              type="text"
              placeholder="Εισάγετε username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{ 
                width: "100%", 
                padding: "10px", 
                background: "#3b4a66",
                border: "1px solid rgba(255,255,255,.12)",
                color: "#f2f6fb",
                borderRadius: 10,
                outline: "none",
                boxSizing: "border-box"
              }}
              required
            />
          </div>
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px", fontSize: "14px" }}>Password</label>
            <input
              type="password"
              placeholder="Εισάγετε password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ 
                width: "100%", 
                padding: "10px",
                background: "#3b4a66",
                border: "1px solid rgba(255,255,255,.12)",
                color: "#f2f6fb",
                borderRadius: 10,
                outline: "none",
                boxSizing: "border-box"
              }}
              required
            />
          </div>
          <button 
            type="submit" 
            style={{ 
              width: "100%", 
              padding: "12px",
              background: "linear-gradient(180deg,#22c55e,#16a34a)",
              border: "none",
              color: "#052e16",
              fontWeight: 700,
              borderRadius: 10,
              cursor: "pointer",
              fontSize: "16px"
            }}
          >
            Είσοδος
          </button>
        </form>
      </div>
    </div>
  );
}

// Main App Component
const KEY = "mini_crm_v12";

const uid = () => Math.random().toString(36).slice(2, 9) + Date.now().toString(36).slice(-4);
const todayStr = () => new Date().toISOString().slice(0, 10);
const formatDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

const defaultState = {
  customers: [],
  products: [],
  charges: [],
  payments: [],
  lastCustomerId: null,
  applyTotalDiscount: false,
};

const API_URL = window.location.origin + '/api.php'; 

async function loadState() {
  try {
    const response = await fetch(API_URL);
    const data = await response.json();
    if (typeof data.applyTotalDiscount !== "boolean") {
      data.applyTotalDiscount = !!data.applyTotalDiscount;
    }
    return { ...defaultState, ...data };
  } catch (e) {
    console.error("Failed to load state from server", e);
    return defaultState;
  }
}

async function saveState(stateData) {
  try {
    await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(stateData)
    });
  } catch (e) {
    console.error("Failed to save state to server", e);
  }
}

const btnStyle = {
  background: 'rgba(59,74,102,.7)',
  border: '1px solid rgba(255,255,255,.12)',
  color: '#f2f6fb',
  padding: '8px 12px',
  borderRadius: 10,
  cursor: 'pointer',
};
const cardStyle = { background: 'linear-gradient(180deg,rgba(255,255,255,.04),rgba(255,255,255,.02))', border: '1px solid rgba(255,255,255,.08)', borderRadius: 14, boxShadow: '0 10px 30px rgba(0,0,0,.25)', margin: '12px 0', padding: 16 };
const inputStyle = { background: '#3b4a66', border: '1px solid rgba(255,255,255,.12)', color: '#f2f6fb', padding: '8px 10px', borderRadius: 10, outline: 'none' };
const iconBtn = { border: 0, background: 'transparent', cursor: 'pointer', fontSize: 16, lineHeight: 1, opacity: 0.9 };

function TabBtn({ children, onClick, active }) {
  return (
    <button onClick={onClick} style={{ ...(active ? { background: 'linear-gradient(180deg,#22c55e,#16a34a)', borderColor: 'transparent', color: '#052e16', fontWeight: 700 } : {}), ...btnStyle }}>
      {children}
    </button>
  );
}

function ProductRow({ p, onDelete, onGoLedger, onSave }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(p.name);
  const [price, setPrice] = useState(String(p.price));

  useEffect(()=>{ setName(p.name); setPrice(String(p.price)); }, [p]);

  return (
    <tr style={{ borderTop: '1px solid rgba(255,255,255,.06)', background: 'rgba(50,64,90,.45)' }}>
      <td style={{ padding: 12 }}>
        {!editing ? (
          <a href="#" onClick={(e) => { e.preventDefault(); onGoLedger(); }} style={{ color: '#8fc1ff', textDecoration: 'underline' }}>{p.name}</a>
        ) : (
          <input value={name} onChange={(e)=>setName(e.target.value)} style={inputStyle} />
        )}
      </td>
      <td style={{ padding: 12 }}>
        {!editing ? <span>{Number(p.price||0).toFixed(2)}</span> : <input type="number" min="0" step="0.01" value={price} onChange={(e)=>setPrice(e.target.value)} style={inputStyle} />}
      </td>
      <td style={{ padding: 12 }}>
        {!editing ? (
          <>
            <button style={btnStyle} onClick={()=>setEditing(true)}>Επεξεργασία</button>
            <button style={{ ...btnStyle, marginLeft: 8 }} onClick={onDelete}>Διαγραφή</button>
          </>
        ) : (
          <>
            <button style={btnStyle} onClick={()=>{ const pName = String(name||'').trim(); const pPrice = Number(price); if(!pName){ alert('όνομα υποχρεωτικό'); return;} if(!isFinite(pPrice)||pPrice<0){ alert('Τιμή μη έγκυρη'); return;} onSave(pName, pPrice); setEditing(false); }}>Αποθήκευση</button>
            <button style={{ ...btnStyle, marginLeft: 8 }} onClick={()=>{ setEditing(false); setName(p.name); setPrice(String(p.price)); }}>Άκυρο</button>
          </>
        )}
      </td>
    </tr>
  );
}

function EditDialogContent({ payload, state, onClose, onSave }) {
  const [formData, setFormData] = useState(null);

  useEffect(()=>{
    if(!payload){ setFormData(null); return; }
    if(payload.kind === 'charge'){
      const ch = state.charges.find(x=>x.id===payload.id); 
      if(!ch){ setFormData(null); return; }
      setFormData({ ...ch });
    } else if(payload.kind === 'payment'){
      const p = state.payments.find(x=>x.id===payload.id); 
      if(!p){ setFormData(null); return; }
      setFormData({ ...p });
    }
  }, [payload, state]);

  if(!payload || !formData) return (
    <div>
      <div>Δεν βρέθηκε.</div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
        <button style={btnStyle} onClick={onClose}>Κλείσιμο</button>
      </div>
    </div>
  );

  if(payload.kind === 'charge'){
    return (
      <form onSubmit={(e)=>{ e.preventDefault(); onSave('charge', formData); }}>
        <h3 style={{ marginTop: 0 }}>Επεξεργασία Χρέωσης</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          <label>Εμπόρευμα:
            <select value={formData.productId} onChange={(e)=>setFormData({...formData, productId: e.target.value})} style={inputStyle}>
              {state.products.map(p=> <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </label>
          <label>Ποσότητα:
            <input type="number" min="0.001" step="0.001" value={formData.qty} onChange={(e)=>setFormData({...formData, qty: e.target.value})} required style={inputStyle} />
          </label>
          <label>Μονάδα:
            <select value={formData.unit} onChange={(e)=>setFormData({...formData, unit: e.target.value})} style={inputStyle}>
              <option value="τεμ.">τεμάχια</option>
              <option value="κιλά">κιλά</option>
            </select>
          </label>
          <label>Τιμή:
            <input type="number" min="0" step="0.01" value={formData.price} onChange={(e)=>setFormData({...formData, price: e.target.value})} required style={inputStyle} />
          </label>
          <label><input type="checkbox" checked={!!formData.discount} onChange={(e)=>setFormData({...formData, discount: e.target.checked})} /> Έκπτωση 9,7%</label>
          <label><input type="checkbox" checked={!!formData.isReturn} onChange={(e)=>setFormData({...formData, isReturn: e.target.checked})} /> Επιστροφή</label>
          <label>Ημερομηνία:
            <input type="date" value={formData.date} onChange={(e)=>setFormData({...formData, date: e.target.value})} required style={inputStyle} />
          </label>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
          <button style={btnStyle} type="button" onClick={onClose}>Άκυρο</button>
          <button style={{ ...btnStyle, background: 'linear-gradient(180deg,#22c55e,#16a34a)', borderColor: 'transparent', color: '#052e16', fontWeight: 700 }} type="submit">Αποθήκευση</button>
        </div>
      </form>
    );
  }

  return (
    <form onSubmit={(e)=>{ e.preventDefault(); onSave('payment', formData); }}>
      <h3 style={{ marginTop: 0 }}>Επεξεργασία Πληρωμής</h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        <label>Ποσό:
          <input type="number" min="0" step="0.01" value={formData.amount} onChange={(e)=>setFormData({...formData, amount: e.target.value})} required style={inputStyle} />
        </label>
        <label>Ημερομηνία:
          <input type="date" value={formData.date} onChange={(e)=>setFormData({...formData, date: e.target.value})} required style={inputStyle} />
        </label>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
        <button style={btnStyle} type="button" onClick={onClose}>Άκυρο</button>
        <button style={{ ...btnStyle, background: 'linear-gradient(180deg,#22c55e,#16a34a)', borderColor: 'transparent', color: '#052e16', fontWeight: 700 }} type="submit">Αποθήκευση</button>
      </div>
    </form>
  );
}

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [state, setState] = useState(defaultState);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadState().then(data => {
      setState(data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!loading) {
      saveState(state);
    }
  }, [state, loading]);
  const [activeTab, setActiveTab] = useState("customers");
  const [customerQuery, setCustomerQuery] = useState("");
  const [productQuery, setProductQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const customerFormRef = useRef(null);
  const productFormRef = useRef(null);
  const chargeFormRef = useRef(null);
  const paymentFormRef = useRef(null);
  const editDialogRef = useRef(null);
  const confirmDialogRef = useRef(null);

  const [editPayload, setEditPayload] = useState(null);
  const [confirmData, setConfirmData] = useState(null);

  // Όλα τα useMemo ΠΡΙΝ το early return
  const customersSortedFiltered = useMemo(() => {
    const q = (customerQuery || "").toLowerCase();
    return state.customers
      .slice()
      .sort((a, b) => (a.lastName || "").localeCompare(b.lastName || "", "el"))
      .filter((c) => !q || (c.firstName || "").toLowerCase().includes(q) || (c.lastName || "").toLowerCase().includes(q) || (c.email || "").toLowerCase().includes(q));
  }, [state.customers, customerQuery]);

  const productsSortedFiltered = useMemo(() => {
    const q = (productQuery || "").toLowerCase();
    return state.products
      .slice()
      .sort((a, b) => (a.name || "").localeCompare(b.name || "", "el"))
      .filter((p) => !q || (p.name || "").toLowerCase().includes(q));
  }, [state.products, productQuery]);

  useEffect(() => {
    const logged = sessionStorage.getItem("loggedIn");
    if (logged === "true") {
      setIsLoggedIn(true);
    }
  }, []);

  

  // ΤΩΡΑ το early return
  if (!isLoggedIn) {
    return <Login onLogin={setIsLoggedIn} />;
  }

  const escapeHtml = (s) => String(s || "").replace(/[&<>\"']/g, (m) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  }[m]));

  const saveStatePatch = (patch) => setState((prev) => ({ ...prev, ...patch }));

  const askConfirmation = (message, onConfirm) => {
    setConfirmData({ message, onConfirm });
    confirmDialogRef.current?.showModal?.();
  };

  const handleConfirmYes = () => {
    if (confirmData?.onConfirm) confirmData.onConfirm();
    confirmDialogRef.current?.close?.();
    setConfirmData(null);
  };

  const handleConfirmNo = () => {
    confirmDialogRef.current?.close?.();
    setConfirmData(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("loggedIn");
    setIsLoggedIn(false);
  };

  const addCustomer = (obj) => {
    setState((s) => ({ ...s, customers: [...s.customers, { id: uid(), ...obj }] }));
  };
  
  const deleteCustomerByIndex = (index) => {
    setState((s) => {
      const next = { ...s };
      next.customers = s.customers.slice();
      next.customers.splice(index, 1);
      if (next.lastCustomerId && !next.customers.find((c) => c.id === next.lastCustomerId)) next.lastCustomerId = null;
      return next;
    });
  };

  const addProduct = (obj) => {
    setState((s) => ({ ...s, products: [...s.products, { id: uid(), ...obj }] }));
  };
  
  const editProduct = (index, patch) => {
    setState((s) => {
      const next = { ...s };
      next.products = s.products.slice();
      next.products[index] = { ...next.products[index], ...patch };
      return next;
    });
  };
  
  const deleteProductByIndex = (index) => {
    setState((s) => {
      const next = { ...s };
      next.products = s.products.slice();
      next.products.splice(index, 1);
      return next;
    });
  };

  const addCharge = (charge) => {
    setState((s) => ({ ...s, charges: [...s.charges, { id: uid(), ...charge }], lastCustomerId: charge.customerId }));
  };
  
  const addPayment = (payment) => {
    setState((s) => ({ ...s, payments: [...s.payments, { id: uid(), ...payment }], lastCustomerId: payment.customerId }));
  };
  
  const deleteCharge = (id) => setState((s) => ({ ...s, charges: s.charges.filter((c) => c.id !== id) }));
  const deletePayment = (id) => setState((s) => ({ ...s, payments: s.payments.filter((p) => p.id !== id) }));

  const openLedgerForCustomer = (cid) => {
    setActiveTab("ledger");
    saveStatePatch({ lastCustomerId: cid });
  };

  const openEditDialog = (kind, id) => {
    setEditPayload({ kind, id });
    setTimeout(() => editDialogRef.current?.showModal?.(), 0);
  };
  
  const closeEditDialog = () => {
    editDialogRef.current?.close?.();
    setEditPayload(null);
  };

  function exportData() {
    const payload = { version: "v14", exportedAt: new Date().toISOString(), state };
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `mini_crm_backup_${todayStr()}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  function importData(file) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const txt = String(reader.result || "");
        const obj = JSON.parse(txt);
        const src = obj && obj.state ? obj.state : obj;
        if (!src || typeof src !== "object") throw new Error("invalid import");
        
        askConfirmation(
          "Η εισαγωγή θα ΑΝΤΙΚΑΤΑΣΤΗΣΕΙ όλα τα τρέχοντα δεδομένα. Συνέχεια;",
          () => {
            const next = {
              customers: Array.isArray(src.customers) ? src.customers : [],
              products: Array.isArray(src.products) ? src.products : [],
              charges: Array.isArray(src.charges) ? src.charges : [],
              payments: Array.isArray(src.payments) ? src.payments : [],
              lastCustomerId: src.lastCustomerId || null,
              applyTotalDiscount: !!src.applyTotalDiscount,
            };
            setState(next);
            alert("Η εισαγωγή ολοκληρώθηκε.");
          }
        );
      } catch (err) {
        console.error(err);
        alert("Αποτυχία εισαγωγής: μη έγκυρο JSON backup.");
      }
    };
    reader.onerror = () => alert("Σφάλμα ανάγνωσης αρχείου.");
    reader.readAsText(file, "utf-8");
  }

  function resetAll() {
    askConfirmation(
      "Θέλεις σίγουρα να διαγράψεις ΟΛΑ τα δεδομένα;",
      () => {
        setState(defaultState);
        alert("Έγινε καθαρισμός.");
      }
    );
  }

  
  
  function handlePrint() {
    if (!state.lastCustomerId) {
      alert("Επίλεξε πελάτη για εκτύπωση");
      return;
    }

    const liveView = document.querySelector('#liveCardView');
    if (!liveView) {
      alert("Δεν βρέθηκε η καρτέλα για εκτύπωση.");
      return;
    }

  // Δημιουργία νέου clean παραθύρου για εκτύπωση
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Εκτύπωση Καρτέλας</title>
          <style>
            body {
              font-family: system-ui, Segoe UI, Roboto, Arial;
              padding: 20px;
            }
            h3 {
              margin-top: 0;
            }
            button {
              display: none !important;
            }
          </style>
        </head>
        <body>
          ${liveView.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();

  // Προαιρετικό: έκλεισε το παράθυρο μετά την εκτύπωση
    printWindow.close();
  }


  return (
    <div style={{ background: "#2a3550", color: "#f2f6fb", minHeight: "100vh", fontFamily: "system-ui, Segoe UI, Roboto, Arial" }}>
      <header style={{ padding: 16, borderBottom: "1px solid rgba(255,255,255,.08)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", alignItems: "center", gap: 12 }}>
          <h1 style={{ margin: 0, fontSize: 20 }}>Πελατολόγιο • Εμπορεύματα • Καρτέλες</h1>
          <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
            <button onClick={exportData} style={btnStyle}>Εξαγωγή</button>
            <label style={{ ...btnStyle, display: "inline-block", cursor: "pointer" }}>
              Εισαγωγή
              <input type="file" accept="application/json" style={{ display: "none" }} onChange={(e) => { const f = e.target.files?.[0]; if (f) importData(f); }} />
            </label>
            <button onClick={resetAll} style={{ ...btnStyle, background: "linear-gradient(180deg,#ef4444,#b91c1c)", borderColor: "transparent" }}>Καθαρισμός</button>
            <button onClick={handleLogout} style={{ ...btnStyle, background: "linear-gradient(180deg,#f59e0b,#d97706)", borderColor: "transparent" }}>Αποσύνδεση</button>
          </div>
        </div>
        <nav style={{ maxWidth: 1100, margin: "10px auto 0", display: "flex", gap: 8, flexWrap: "wrap" }}>
          <TabBtn active={activeTab === "customers"} onClick={() => setActiveTab("customers")}>Πελάτες</TabBtn>
          <TabBtn active={activeTab === "products"} onClick={() => setActiveTab("products")}>Εμπορεύματα</TabBtn>
          <TabBtn active={activeTab === "ledger"} onClick={() => setActiveTab("ledger")}>Καρτέλα</TabBtn>
        </nav>
      </header>

      <main style={{ maxWidth: 1100, margin: "16px auto", padding: "0 16px" }}>
        {activeTab === "customers" && (
          <section>
            <div style={cardStyle}>
              <h2 style={{ marginTop: 0 }}>Πελάτες</h2>
              <form ref={customerFormRef} onSubmit={(e) => { e.preventDefault(); const fd = new FormData(e.target); addCustomer(Object.fromEntries(fd)); e.target.reset(); }} style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                <input name="lastName" placeholder="Επώνυμο" required style={inputStyle} />
                <input name="firstName" placeholder="Όνομα" required style={inputStyle} />
                <input name="phone" placeholder="Τηλέφωνο" style={inputStyle} />
                <input name="mobile" placeholder="Κινητό" style={inputStyle} />
                <input name="email" placeholder="Email" type="email" style={inputStyle} />
                <button type="submit" style={{ ...btnStyle, background: "linear-gradient(180deg,#22c55e,#16a34a)", borderColor: "transparent", color: "#052e16", fontWeight: 700 }}>Προσθήκη</button>
              </form>

              <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 12 }}>
                <input placeholder="Αναζήτηση (όνομα, επώνυμο, email)" value={customerQuery} onChange={(e) => setCustomerQuery(e.target.value)} style={{ minWidth: 220, ...inputStyle }} />
                <div style={{ marginLeft: "auto" }}>{state.customers.length} πελάτες</div>
              </div>

              <div style={{ ...cardStyle, marginTop: 12 }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ textAlign: "left", textTransform: "uppercase", fontSize: 12 }}>
                      <th style={{ padding: 10 }}>Επώνυμο</th>
                      <th style={{ padding: 10 }}>Όνομα</th>
                      <th style={{ padding: 10 }}>Τηλέφωνο</th>
                      <th style={{ padding: 10 }}>Κινητό</th>
                      <th style={{ padding: 10 }}>Email</th>
                      <th style={{ padding: 10 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {customersSortedFiltered.map((c) => (
                      <tr key={c.id} style={{ borderTop: "1px solid rgba(255,255,255,.06)", background: "rgba(50,64,90,.45)" }}>
                        <td style={{ padding: 12 }}>{c.lastName}</td>
                        <td style={{ padding: 12 }}>{c.firstName}</td>
                        <td style={{ padding: 12 }}>{c.phone}</td>
                        <td style={{ padding: 12 }}>{c.mobile}</td>
                        <td style={{ padding: 12 }}>{c.email}</td>
                        <td style={{ padding: 12 }}>
                          <button style={btnStyle} onClick={() => openLedgerForCustomer(c.id)}>Καρτέλα</button>
                          <button style={{ ...btnStyle, marginLeft: 8, background: "linear-gradient(180deg,#ef4444,#b91c1c)", borderColor: "transparent" }} onClick={() => askConfirmation('Είσαι σίγουρος ότι θέλεις να διαγράψεις;', () => deleteCustomerByIndex(state.customers.indexOf(c)))}>Διαγραφή</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}

        {activeTab === "products" && (
          <section>
            <div style={cardStyle}>
              <h2 style={{ marginTop: 0 }}>Εμπορεύματα</h2>
              <form ref={productFormRef} onSubmit={(e) => { e.preventDefault(); const fd = new FormData(e.target); const name = String(fd.get('name')||'').trim(); const price = Number(fd.get('price')); if (!name) { alert('Το όνομα είναι υποχρεωτικό.'); return;} if(!isFinite(price)||price<0){ alert('Μη έγκυρη τιμή προϊόντος.'); return;} addProduct({ name, price }); e.target.reset(); }} style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                <input name="name" placeholder="Όνομα εμπορεύματος" required style={inputStyle} />
                <input name="price" type="number" min="0" step="0.01" placeholder="Τιμή μονάδας" required style={inputStyle} />
                <button type="submit" style={{ ...btnStyle, background: 'linear-gradient(180deg,#22c55e,#16a34a)', borderColor: 'transparent', color: '#052e16', fontWeight: 700 }}>Προσθήκη</button>
              </form>

              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
                <input placeholder="Αναζήτηση εμπορεύματος" value={productQuery} onChange={(e) => setProductQuery(e.target.value)} style={{ minWidth: 220, ...inputStyle }} />
                <div style={{ marginLeft: 'auto' }}>{state.products.length} εμπορεύματα</div>
              </div>

              <div style={{ ...cardStyle, marginTop: 12 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ textAlign: 'left', textTransform: 'uppercase', fontSize: 12 }}>
                      <th style={{ padding: 10 }}>Όνομα</th>
                      <th style={{ padding: 10 }}>Τιμή</th>
                      <th style={{ padding: 10 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {productsSortedFiltered.map((p) => (
                      <ProductRow key={p.id} p={p} onDelete={() => askConfirmation('Είσαι σίγουρος ότι θέλεις να διαγράψεις;', () => deleteProductByIndex(state.products.indexOf(p)))} onGoLedger={() => { if (state.customers.length===0) { setActiveTab('customers'); alert('Πρόσθεσε πρώτα έναν πελάτη.'); return; } setActiveTab('ledger'); saveStatePatch({ lastCustomerId: state.customers[0]?.id || null }); const f = chargeFormRef.current; setTimeout(()=>{ if(f){ const prodSel = f.querySelector('select[name="product"]'); if(prodSel) prodSel.value = p.id; const priceInput = f.querySelector('input[name="price"]'); if(priceInput) priceInput.value = String(p.price); } }, 0); }} onSave={(newName, newPrice) => { const idx = state.products.indexOf(p); if(idx>=0) editProduct(idx, { name: newName, price: newPrice }); }} />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}

        {activeTab === "ledger" && (
          <section>
            <div style={cardStyle}>
              <h2 style={{ marginTop: 0 }}>Καρτέλα Πελάτη</h2>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>Πελάτης:
                  <select value={state.lastCustomerId||''} onChange={(e) => saveStatePatch({ lastCustomerId: e.target.value })} style={inputStyle}>
                    <option value="">-- επίλεξε --</option>
                    {state.customers.map(c=> <option key={c.id} value={c.id}>{`${c.lastName||''} ${c.firstName||''}`.trim()}</option>)}
                  </select>
                </label>
                <label>Από:
                  <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputStyle} />
                </label>
                <label>Έως:
                  <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputStyle} />
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}><input type="checkbox" checked={!!state.applyTotalDiscount} onChange={(e) => saveStatePatch({ applyTotalDiscount: e.target.checked })} /> Έκπτωση 9,7%</label>
                <button onClick={handlePrint} style={btnStyle}>
  Εκτύπωση
                </button>
              </div>

              <h3>Νέα Χρέωση</h3>
              <form ref={chargeFormRef} onSubmit={(e)=>{ e.preventDefault(); if(!state.lastCustomerId){ alert('Επίλεξε πελάτη'); return;} const fd = new FormData(e.target); const price = Number(fd.get('price')); const qty = Number(fd.get('qty')); if(!isFinite(price)||price<0){ alert('Μη έγκυρη τιμή.'); return;} if(!isFinite(qty)||qty<=0){ alert('Ποσότητα > 0'); return;} addCharge({ customerId: state.lastCustomerId, productId: fd.get('product'), qty, unit: fd.get('unit'), price, date: fd.get('date'), discount: !!fd.get('discount'), isReturn: !!fd.get('isReturn') }); e.target.reset(); e.target.qty.value = 1; e.target.unit.value='τεμ.'; e.target.date.value = todayStr(); }} style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 8 }}>
                <select name="product" style={inputStyle} required
                  onChange={(e) => {
                    const prod = state.products.find(p => p.id === e.target.value);
                    const priceInput = chargeFormRef.current?.querySelector('input[name="price"]');
                    if (prod && priceInput) {
                      priceInput.value = prod.price;
                    }
                   }}
                >
                  <option value="">-- εμπόρευμα --</option>
                  {state.products.map(p=> <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
                <input name="qty" type="number" min="1" step="1" defaultValue={1} style={inputStyle} required />
                <select name="unit" defaultValue="τεμ." style={inputStyle}>
                  <option value="τεμ.">τεμάχια</option>
                  <option value="κιλά">κιλά</option>
                </select>
                <input name="price" type="number" min="0" step="0.01" placeholder="Τιμή" required style={inputStyle} />
                <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}><input name="discount" type="checkbox" /> Έκπτωση 9,7%</label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}><input name="isReturn" type="checkbox" /> Επιστροφή</label>
                <input name="date" type="date" defaultValue={todayStr()} style={inputStyle} required />
                <button type="submit" style={{ ...btnStyle, background: 'linear-gradient(180deg,#22c55e,#16a34a)', borderColor: 'transparent', color: '#052e16', fontWeight: 700 }}>Καταχώρηση</button>
              </form>

              <h3>Πληρωμές</h3>
              <form ref={paymentFormRef} onSubmit={(e)=>{ e.preventDefault(); if(!state.lastCustomerId){ alert('Επίλεξε πελάτη'); return;} const fd = new FormData(e.target); const amount = Number(fd.get('amount')); if(!isFinite(amount)||amount<0){ alert('Μη έγκυρο ποσό.'); return;} addPayment({ customerId: state.lastCustomerId, amount, date: fd.get('date') }); e.target.reset(); e.target.date.value = todayStr(); }} style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                <input name="amount" type="number" min="0" step="0.01" placeholder="Ποσό" required style={inputStyle} />
                <input name="date" type="date" defaultValue={todayStr()} style={inputStyle} required />
                <button type="submit" style={{ ...btnStyle, background: 'linear-gradient(180deg,#22c55e,#16a34a)', borderColor: 'transparent', color: '#052e16', fontWeight: 700 }}>Καταχώρηση</button>
              </form>

              <div id="liveCardView" style={{ marginTop: 12, ...cardStyle }}>
                <h3 style={{ marginTop: 0 }}>Προβολή Καρτέλας (ζωντανά)</h3>
                <div>
                  {!state.lastCustomerId && <div>Επίλεξε πελάτη για να δεις την καρτέλα.</div>}
                  {state.lastCustomerId && (() => {
                    const cid = state.lastCustomerId;
                    const customer = state.customers.find(c=>c.id===cid);
                    const from = fromDate || '';
                    const to = toDate || '';
                    const inRangeLocal = (d) => { if(!d) return false; return (!from || d >= from) && (!to || d <= to); };
                    const charges = state.charges.filter(ch=>ch.customerId===cid && inRangeLocal(ch.date));
                    const pays = state.payments.filter(p=>p.customerId===cid && inRangeLocal(p.date));

                    const totalDiscOn = !!state.applyTotalDiscount;
                    const sumCharges = charges.reduce((a,ch)=>{ const gross=(Number(ch.qty)||0)*(Number(ch.price)||0); if(ch.isReturn) return a; const line = (!totalDiscOn && ch.discount) ? gross*0.903 : gross; return a + line; },0);
                    const sumReturns = charges.reduce((a,ch)=>{ const gross=(Number(ch.qty)||0)*(Number(ch.price)||0); return ch.isReturn ? a + gross : a; },0);
                    const sumP = pays.reduce((a,p)=> a + (Number(p.amount)||0), 0);
                    const netAfter = (sumCharges - sumReturns) * (totalDiscOn ? 0.903 : 1);

                    return (
                      <div>
                        <div><strong>Καρτέλα:</strong> {customer?.lastName} {customer?.firstName}</div>
                        {(from||to) && <div><strong>Περίοδος:</strong> {from?formatDate(from):'—'} έως {to?formatDate(to):'—'}</div>}
                        <hr />
                        <div>
                          {charges.length ? charges.map(ch => {
                            const p = state.products.find(x=>x.id===ch.productId);
                            const prodName = p ? p.name : '(διαγραφ.)';
                            const unitPrice = Number(ch.price)||0;
                            const qtyNum = Number(ch.qty)||0;
                            const gross = qtyNum * unitPrice;
                            let net = gross;
                            let badge = null;
                            if(ch.isReturn) {
                              net = -gross;
                              badge = <span style={{ background: '#ef4444', color: '#fff', padding: '2px 8px', borderRadius: 6, fontSize: 12, fontWeight: 600 }}>ΕΠΙΣΤΡΟΦΗ</span>;
                            } else if(!totalDiscOn && ch.discount) {
                              net = gross * 0.903;
                              badge = <span style={{ background: '#22c55e', color: '#052e16', padding: '2px 8px', borderRadius: 6, fontSize: 12, fontWeight: 600 }}>ΕΚΠΤΩΣΗ</span>;
                            }
                            return (
                              <div key={ch.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center', margin: '6px 0' }}>
                                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                  <span>{formatDate(ch.date)} — {prodName}: {qtyNum} {ch.unit} × {unitPrice.toFixed(2)}€ = {net.toFixed(2)}€</span>
                                  {badge}
                                </div>
                                <span style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
                                  <button style={iconBtn} onClick={()=>openEditDialog('charge', ch.id)}>✏️</button>
                                  <button style={{ ...iconBtn, color: '#ffb4b4' }} onClick={()=>askConfirmation('Διαγραφή;', () => deleteCharge(ch.id))}>🗑️</button>
                                </span>
                              </div>
                            );
                          }) : <div>Χωρίς χρεώσεις.</div>}
                        </div>

                        <hr />
                        <div>
                          {pays.length ? pays.map(pay => (
                            <div key={pay.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center', margin: '6px 0' }}>
                              <span>{formatDate(pay.date)} — Πληρωμή: {Number(pay.amount).toFixed(2)}€</span>
                              <span>
                                <button style={iconBtn} onClick={()=>openEditDialog('payment', pay.id)}>✏️</button>
                                <button style={{ ...iconBtn, color: '#ffb4b4' }} onClick={()=>askConfirmation('Διαγραφή;', () => deletePayment(pay.id))}>🗑️</button>
                              </span>
                            </div>
                          )) : <div>Χωρίς πληρωμές.</div>}
                        </div>

                        <hr />
                        <div><strong>Σύνολο Χρεώσεων:</strong> {sumCharges.toFixed(2)}€</div>
                        <div><strong>Σύνολο Επιστροφών:</strong> {sumReturns.toFixed(2)}€</div>
                        {totalDiscOn && <div><strong>Έκπτωση 9,7%:</strong> -{((sumCharges - sumReturns) * 0.097).toFixed(2)}€</div>}
                        <div><strong>Σύνολο Πληρωμών:</strong> {sumP.toFixed(2)}€</div>
                        <div><strong>Υπόλοιπο:</strong> {(netAfter - sumP).toFixed(2)}€</div>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      <dialog ref={confirmDialogRef} style={{ borderRadius: 12, padding: 16, border: '1px solid rgba(255,255,255,.15)', background: '#2a3550', color: '#f2f6fb' }}>
        <h3 style={{ marginTop: 0 }}>Επιβεβαίωση</h3>
        <p>{confirmData?.message}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={handleConfirmNo} style={btnStyle}>Άκυρο</button>
          <button onClick={handleConfirmYes} style={{ ...btnStyle, background: 'linear-gradient(180deg,#ef4444,#b91c1c)', borderColor: 'transparent' }}>Ναι</button>
        </div>
      </dialog>

      <dialog ref={editDialogRef} style={{ borderRadius: 12, padding: 16, border: '1px solid rgba(255,255,255,.15)', background: '#2a3550', color: '#f2f6fb' }}>
        <EditDialogContent payload={editPayload} state={state} onClose={closeEditDialog} onSave={(k, data) => {
          if (k === 'charge') {
            setState((s) => {
              const next = { ...s };
              const ch = next.charges.find((c) => c.id === data.id);
              if (ch) Object.assign(ch, data);
              return next;
            });
          } else if (k === 'payment') {
            setState((s) => {
              const next = { ...s };
              const p = next.payments.find((x) => x.id === data.id);
              if (p) Object.assign(p, data);
              return next;
            });
          }
          closeEditDialog();
        }} />
      </dialog>

      <div id="printArea" style={{ display: 'none' }} />
    </div>
  );
}